var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEisen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 940.47 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#a8a7ff;}.e{clip-path:url(#c);}.f{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 240,
    y: 0,
    width: 700.47,
    height: 192
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 192,
    height: 192,
    rx: 16,
    ry: 16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M127.04,143.27c-.3-6.9-.61-14.08-.94-20.94-2.63,3-5.69,5.61-9.1,7.72l-34.29-11.21c-18.29,12.3-45.52,29.24-62.71,40.39,35.81,28.62,86.95,.21,86.95,.21l4.26-3.43h16.38c-.18-4.06-.36-8.35-.55-12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M140.76,52.74c-6.69,4.26-13.36,8.54-19.31,12.4,4.25,3.51,7.75,7.88,10.26,12.84l-7,19.51c1.52,22.24,2.46,51.68,3.63,74.5,42.69-16.7,43.66-75.2,43.66-75.2l-31.24-44.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M85.05,32.57l-4.26,3.43h-16.38c.48,10.93,.97,22.65,1.49,33.67,2.63-3,5.69-5.61,9.1-7.72l34.29,11.21c9.66-6.51,20.81-13.62,31.47-20.43h0c11.62-7.41,23.27-14.79,31.24-19.96-35.81-28.62-86.95-.21-86.95-.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 140.76,
    y: 52.74,
    width: 0,
    height: 0,
    transform: "translate(30.64 155.05) rotate(-63.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M60.29,114.01l7-19.51c-1.52-22.24-2.46-51.68-3.63-74.5C20.96,36.7,20,95.2,20,95.2l31.24,44.06c6.68-4.26,13.36-8.54,19.31-12.4-4.25-3.51-7.75-7.88-10.26-12.84Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M372.2,62.76l11.8-28.4-4.38-10.36c-22.71,9.72-70.52,9.89-100.21,8.9l-.14-7.27c-4.83-.4-17.93-1.29-22.93-1.63l-12.39,9c2.32,3.1-3.85,126.94-3.96,135,3.23,0,40.1,0,41.99,0v-.03l90.21-.57,11.8-28.4-4.38-10.36c-22.21,9.51-68.42,9.88-98.21,8.97l-.51-26.76c29.84-4.76,55.2-7.15,82.72,11.39v-50.47c-27.56,18.59-53.39,16.2-83.25,11.26l-.41-21.75c40.85,3.58,92.24,1.49,92.24,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M750.2,62.76l11.8-28.4-4.38-10.36c-22.71,9.72-70.52,9.89-100.21,8.9l-.14-7.27c-4.83-.4-17.93-1.29-22.93-1.63l-12.39,9c2.32,3.1-3.85,126.94-3.96,135,3.23,0,40.1,0,41.99,0v-.03l90.21-.57,11.8-28.4-4.38-10.36c-22.21,9.51-68.42,9.88-98.21,8.97l-.51-26.76c29.84-4.76,55.2-7.15,82.72,11.39v-50.47c-27.56,18.59-53.39,16.2-83.25,11.26l-.41-21.75c40.85,3.58,92.24,1.49,92.24,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M912.06,168h26.36l-2.71-142.37c-4.83-.4-17.92-1.29-22.93-1.63l-12.39,9c1.85,9.97-1.35,67.22-1.67,78.47l-92.33-87.47h0l-13.07,1.63c-3.2,4.33-10.06,13.61-13.3,18h0l.32,106.36,25.2,18h11.24c-7.8-36.34-10.35-72.9-10.98-100.09h0l106.26,100.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M598.54,59.19c.41,.02,8.15-24.2,8.15-24.2l-7.26-6.58c-39.72-5.66-107.71-3.18-107.03-3.13-31.13,21.88-20.38,69.22-20.37,69.22l11.8,28.4h0c26.32-17.76,47.41-15.49,76.21-12.74,1.16,3.26,5.88,19.35,6.96,22.98-27.23,2.43-71.61,8.08-100.88-4.07l-4.38,10.36,12.11,28.56h103.51c4.26-2.87,7.35-6.38,10.47-9.86l-.07-.18c23.96-41.86,7.4-61.91-1.91-87.21h0c-10.3,15.53-53.68,19.62-75.85,13.88-1.44-4.04-6.39-21.16-7.7-25.59,30.98-6.06,77.3-.96,96.23,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M430.69,25.05l-15.33-1.05-12.39,9c2.32,3.1-3.85,126.94-3.96,135h41.99l-2.71-142.37-7.6-.58Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEisen);
export default __webpack_public_path__ + "static/media/eisen.4130620bbe66c5c1f90f335c59025aad.svg";
export { ForwardRef as ReactComponent };